var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('v-spacer'),_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }